// extracted by mini-css-extract-plugin
export default {"skeleton":"cjOJ0LFmea_pdp","gradient-flow":"e6nroYpWj2_pdp"};